module.exports = __webpack_public_path__ + "img/empty-sheets.bc499906.svg";